// extracted by mini-css-extract-plugin
export default {"title":"PopupChainContent_title__P7v82","select":"PopupChainContent_select__K8VmW"};